import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'rewardTemplate',
})
export class TemplateRewardPipe implements PipeTransform {
  transform(reward: string): string {
    const currency = reward[reward.indexOf('€')];
    const onlyPrice = reward.replace(/[\s€]/g, '');
    const priceFragments =
      onlyPrice.split('.').length > 1
        ? onlyPrice.split('.')
        : onlyPrice.split(',');
    return `${priceFragments[0]}<sup>${currency}</sup>,${priceFragments[1]}`;
  }
}
